import { createAction } from "@reduxjs/toolkit"
import {
  FETCH_PVS_REQUEST,
  CREATE_PVS_REQUEST,
  UPDATE_PVS_REQUEST,
  DELETE_PVS_REQUEST,
  FETCH_PVS_DETAILS_REQUEST,
  FETCH_PVS_CATEGORY_REQUEST,
  CREATE_PVS_CATEGORY_REQUEST,
  UPDATE_PVS_CATEGORY_REQUEST,
  FETCH_PVS_CATEGORY_DETAILS_REQUEST,
  FETCH_PVS_SUBCATEGORY_REQUEST,
  CREATE_PVS_SUBCATEGORY_REQUEST,
  UPDATE_PVS_SUBCATEGORY_REQUEST,
  FETCH_PVS_SUBCATEGORY_DETAILS_REQUEST,
  FETCH_PVS_KEYWORD_REQUEST,
  CREATE_PVS_KEYWORD_REQUEST,
  UPDATE_PVS_KEYWORD_REQUEST,
  FETCH_PVS_KEYWORD_DETAILS_REQUEST,
  FETCH_PVS_BRAND_REQUEST,
  RESET_PVS_STATE,
  RESET_PVS_KEYWORD_STATE,
  RESET_PVS_CATEGORY_STATE,
  RESET_PVS_SUBCATEGORY_STATE,
  ALL_BAZAAR_LIST_REQUEST,
  FETCH_STALL_LIST_REQUEST,
  GET_BOOKING_LIST_REQUEST,
  SUBMIT_BOOKING_REQUEST,
  FETCH_BOOKING_DETAILS_REQUEST,
  ADD_BOOKING_PAYMENT_REQUEST,
  RESEND_INVOICE_REQUEST,
  GET_USER_BILLING_INFO_REQUEST,
  REGENERATE_INVOICE_REQUEST,
  DOWNLOAD_INVOICES_REQUEST,
  DOWNLOAD_BOOKING_REPORT_REQUEST,
  DOWNLOAD_BALANCE_REPORT_REQUEST,
  GET_PVS_DETAILS_REQUEST,
  UPDATE_PVS_REGISTRATION_REQUEST,
  VERIFY_PVS_REGISTRATION_PAYMENT_REQUEST,
  GET_BAZAAR_STALL_DETAILS_REQUEST,
  UPDATE_BAZAAR_STALL_DETAILS_REQUEST,
  GET_BAZAAR_DETAILS_REQUEST,
  ADD_BAZAAR_REQUEST,
  ADD_BAZAAR_STALL_DETAILS_REQUEST,
  CANCEL_STALL_BOOKING_REQUEST,
  GET_PAYMENT_STATISTICS_REQUEST,
  FETCH_PRODUCTS_REQUEST,
  CREATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_REQUEST,
  DELETE_PRODUCT_REQUEST,
  FETCH_PRODUCT_DETAILS_REQUEST,
} from "../types/pvs"
/* PVS */

// export const fetchKeywords = (data) => ({
//   type: FETCH_KEYWORDS_REQUEST,
//   payload: data,
// });

export const updatePvsRegistration = data => ({
  type: UPDATE_PVS_REGISTRATION_REQUEST,
  payload: { data },
})

export const verifyPvsRegistrationPayment = data => ({
  type: VERIFY_PVS_REGISTRATION_PAYMENT_REQUEST,
  payload: { data },
})

export const fetchPvs = pvsData => ({
  type: FETCH_PVS_REQUEST,
  payload: pvsData,
})

export const createPvs = pvsData => ({
  type: CREATE_PVS_REQUEST,
  payload: pvsData,
})

export const updatePvs = (pvsData, enc_pvs_entry_id) => ({
  type: UPDATE_PVS_REQUEST,
  payload: { pvsData, enc_pvs_entry_id },
})

export const deletePvs = userId => ({
  type: DELETE_PVS_REQUEST,
  payload: userId,
})

/* PVS Category */
export const fetchPvsCategory = pvsData => ({
  type: FETCH_PVS_CATEGORY_REQUEST,
  payload: pvsData,
})
export const fetchPvsCategoryDetails = pvsData => ({
  type: FETCH_PVS_CATEGORY_DETAILS_REQUEST,
  payload: pvsData,
})

export const createPvsCategory = pvsData => ({
  type: CREATE_PVS_CATEGORY_REQUEST,
  payload: pvsData,
})

export const updatePvsCategory = (pvsData, enc_pvs_cat_id) => ({
  type: UPDATE_PVS_CATEGORY_REQUEST,
  payload: { pvsData, enc_pvs_cat_id },
})

// All Bazaar List
export const fetchBazaarList = (bazaarData, token) => ({
  type: ALL_BAZAAR_LIST_REQUEST,
  payload: { bazaarData, token },
})

/* PVS Subcategory */
export const fetchPvsSubcategory = pvsData => ({
  type: FETCH_PVS_SUBCATEGORY_REQUEST,
  payload: pvsData,
})
export const fetchPvsSubcategoryDetails = pvsData => ({
  type: FETCH_PVS_SUBCATEGORY_DETAILS_REQUEST,
  payload: pvsData,
})

export const createPvsSubcategory = pvsData => ({
  type: CREATE_PVS_SUBCATEGORY_REQUEST,
  payload: pvsData,
})

export const updatePvsSubcategory = (pvsData, enc_pvs_subcat_id) => ({
  type: UPDATE_PVS_SUBCATEGORY_REQUEST,
  payload: { pvsData, enc_pvs_subcat_id },
})

/* PVS Keyword */
export const fetchPvsKeyword = pvsData => ({
  type: FETCH_PVS_KEYWORD_REQUEST,
  payload: pvsData,
})
export const fetchPvsKeywordDetails = pvsData => ({
  type: FETCH_PVS_KEYWORD_DETAILS_REQUEST,
  payload: pvsData,
})

export const createPvsKeyword = pvsData => ({
  type: CREATE_PVS_KEYWORD_REQUEST,
  payload: pvsData,
})

export const updatePvsKeyword = pvsData => ({
  type: UPDATE_PVS_KEYWORD_REQUEST,
  payload: { pvsData },
})

/* PVS Brand */
export const fetchPvsBrand = pvsData => ({
  type: FETCH_PVS_BRAND_REQUEST,
  payload: pvsData,
})

// Fetch Stall List
export const fetchStallList = (data, token) => ({
  type: FETCH_STALL_LIST_REQUEST,
  payload: { data, token },
})

// Fetch PVS Details
export const getPvsDetails = data => ({
  type: GET_PVS_DETAILS_REQUEST,
  payload: { data },
})

// Fetch PVS Details
export const fetchPvsDetails = (pvsData, token) => ({
  type: FETCH_PVS_DETAILS_REQUEST,
  payload: { pvsData, token },
})

export const getBookingList = (data, token) => ({
  type: GET_BOOKING_LIST_REQUEST,
  payload: { data, token },
})

export const submitStallBooking = (data, token) => ({
  type: SUBMIT_BOOKING_REQUEST,
  payload: { data, token },
})

export const fetchBookingDetails = (data, token) => ({
  type: FETCH_BOOKING_DETAILS_REQUEST,
  payload: { data, token },
})

export const addBookingPayment = (data, token) => ({
  type: ADD_BOOKING_PAYMENT_REQUEST,
  payload: { data, token },
})

export const resendInvoiceAction = (data, token) => ({
  type: RESEND_INVOICE_REQUEST,
  payload: { data, token },
})

export const getUserBillingInfo = (data, token) => ({
  type: GET_USER_BILLING_INFO_REQUEST,
  payload: { data, token },
})

export const regenerateInvoice = (data, token) => ({
  type: REGENERATE_INVOICE_REQUEST,
  payload: { data, token },
})

export const downloadInvoices = (data, token) => ({
  type: DOWNLOAD_INVOICES_REQUEST,
  payload: { data, token },
})

export const downloadBookingReport = (data, token) => ({
  type: DOWNLOAD_BOOKING_REPORT_REQUEST,
  payload: { data, token },
})

export const downloadBalanceReport = (data, token) => ({
  type: DOWNLOAD_BALANCE_REPORT_REQUEST,
  payload: { data, token },
})

export const getBazaarStallDetails = data => ({
  type: GET_BAZAAR_STALL_DETAILS_REQUEST,
  payload: { data },
})

export const updateBazaarStallDetails = data => ({
  type: UPDATE_BAZAAR_STALL_DETAILS_REQUEST,
  payload: { data },
})

export const addBazaarStallDetails = data => ({
  type: ADD_BAZAAR_STALL_DETAILS_REQUEST,
  payload: { data },
})

export const getBazaarDetails = data => ({
  type: GET_BAZAAR_DETAILS_REQUEST,
  payload: { data },
})

export const addBazaar = data => ({
  type: ADD_BAZAAR_REQUEST,
  payload: { data },
})

export const cancelStallBooking = data => ({
  type: CANCEL_STALL_BOOKING_REQUEST,
  payload: { data },
})

// Reset State
export const resetPvsState = () => ({
  type: RESET_PVS_STATE,
})
export const resetPvsKeywordState = () => ({
  type: RESET_PVS_KEYWORD_STATE,
})
export const resetPvsCategoryState = () => ({
  type: RESET_PVS_CATEGORY_STATE,
})
export const resetPvsSubcategoryState = () => ({
  type: RESET_PVS_SUBCATEGORY_STATE,
})

// Get Payment Statistics
export const getPaymentStatistics = data => ({
  type: GET_PAYMENT_STATISTICS_REQUEST,
  payload: data,
})

/* Product Actions */
export const fetchProducts = () => ({
  type: FETCH_PRODUCTS_REQUEST,
})

export const createProduct = data => ({
  type: CREATE_PRODUCT_REQUEST,
  payload: { data },
})

export const updateProduct = data => ({
  type: UPDATE_PRODUCT_REQUEST,
  payload: { data },
})

export const deleteProduct = enc_product_id => ({
  type: DELETE_PRODUCT_REQUEST,
  payload: enc_product_id,
})

export const fetchProductDetails = data => ({
  type: FETCH_PRODUCT_DETAILS_REQUEST,
  payload: { data },
})
